{
  "satis_firma": {
    "Baslik": "Satış Firmaları",
    "Ad": "Firma Adı",
    "Durum": "Durum",
    "Arama": "Arama",
    "Ara": "Ara",
    "Temizle": "Temizle",
    "Kapat": "Kapat",
    "Yenile": "Yenile",
    "Data Yenile": "Verileri Güncelle",
    "Ekle": "Firma Ekle",
    "Filtrele": "Filtrele",
    "Duzenle": "Düzenle",
    "Sil": "Sil",
    "Kaydet": "Kaydet",
    "Guncelle": "Güncelle",
    "Vazgec": "Vazgeç",
    "Iptal": "İptal",
    "Hepsi": "Hepsi",
    "Aktif": "Aktif",
    "Pasif": "Pasif",
    "ARA": "Ara"
  }
}
